<template>
  <div class="onlinetest">
    <div v-if="showloading" style="position: fixed;width: 100%;left: 0;top:0;height: 100vh;background: rgba(34, 34, 34, 0.5);align-items: center;justify-content: center;display: flex;">
      <img src="../assets/img/loading.gif">
    </div>
    <div class="top">
      <img src="../assets/img/avatar.png" style="width: 80px;height: 100px;">
      <div class="info" style="color: #fff;margin-left: 30px;">
        <div class="" style="color: #fff;">
          姓名：×××

        </div>
        <div class="" style="color: #fff;">
          性别：×
        </div>
        <div class="" style="color: #fff;">
          准考证号：1111111111
        </div>
        <div class="" style="color: #fff;">
          证件号码：1111111111111111111
        </div>
      </div>
      <div class="font18 flex1 text-center" style="color: #fff;font-weight: bold;">
        {{title}}
      </div>
      <div class="datetime" style="color: #ffff42;font-weight: bold;margin-right: 30px;">
        科目剩余时间：{{timeString}}
      </div>
      <div class="btn" style="margin-right: 10px;" @click="handleSave">
        暂存
      </div>
      <div class="btn" @click="handleAlertTips">
        交卷
      </div>
    </div>
    <div class="flex">
      <div class="left">
        <template v-for="item in leftList" v-if="item.list.length>0">
          <div class="title font14 text-center" style="margin-top: 10px;">
            {{item.name}}
          </div>
         <div class="list">

            <template v-for="voo,index in item.list">
              <div @click="mark('#ddebf6');;cindex=voo.index">{{voo.index+1}}
                <span class="star" v-if="!voo.obj.isDone && !voo.obj.isTag ">*</span>
                <span class="doublt" v-if="voo.obj.isTag">?</span>
              </div>
            </template>

          </div>
        </template>
       <!-- <div class="title font14 text-center">
          判断题
        </div>
        <div class="list">

          <template v-for="item,index in list" v-if="item.questionStatus==0">
            <div @click="cindex=index">{{index+1}}
              <span class="star" v-if="!item.isDone && !item.isTag ">*</span>
              <span class="doublt" v-if="item.isTag">?</span>
            </div>
          </template>

        </div>
        <div class="title font14 text-center" style="margin-top: 10px;">
          单项选择题
        </div>
        <div class="list">

          <template v-for="item,index in list" v-if="item.questionStatus==1">
            <div @click="cindex=index">{{index+1}}
              <span class="star" v-if="!item.isDone && !item.isTag ">*</span>
              <span class="doublt" v-if="item.isTag">?</span>
            </div>
          </template>

        </div>
        <div class="title font14 text-center" style="margin-top: 10px;">
          多项选择题
        </div>
        <div class="list">
          <template v-for="item,index in list" v-if="item.questionStatus==2">
            <div @click="cindex=index">{{index+1}}
              <span class="star" v-if="!item.isDone && !item.isTag ">*</span>
              <span class="doublt" v-if="item.isTag">?</span>
            </div>
          </template>
        </div>
        <div class="title font14 text-center" style="margin-top: 10px;" v-if="islow">
          不定项选择题
        </div>
        <div class="list">
          <template v-for="item,index in list" v-if="islow && (item.questionStatus==3 || item.questionStatus==4)">
            <div @click="cindex=index">{{index+1}}
              <span class="star" v-if="!item.isDone && !item.isTag ">*</span>
              <span class="doublt" v-if="item.isTag">?</span>
            </div>
          </template>
        </div>
        <div class="title font14 text-center" style="margin-top: 10px;" v-if="!islow">
          计算分析题
        </div>
        <div class="list">
          <template v-for="item,index in list" v-if="!islow && (item.questionStatus==3)">
            <div @click="cindex=index">{{index+1}}
              <span class="star" v-if="!item.isDone && !item.isTag ">*</span>
              <span class="doublt" v-if="item.isTag">?</span>
            </div>
          </template>
        </div>
        <div class="title font14 text-center" style="margin-top: 10px;" v-if="!islow">
          综合题
        </div>
        <div class="list">
          <template v-for="item,index in list" v-if="!islow && (item.questionStatus==4)">
            <div @click="cindex=index">{{index+1}}
              <span class="star" v-if="!item.isDone && !item.isTag ">*</span>
              <span class="doublt" v-if="item.isTag">?</span>
            </div>
          </template>
        </div>
        <div class="title font14 text-center" style="margin-top: 10px;" v-if="!islow">
          完形填空
        </div>
        <div class="list">
          <template v-for="item,index in list" v-if="!islow && (item.questionStatus==5)">
            <div @click="cindex=index">{{index+1}}
              <span class="star" v-if="!item.isDone && !item.isTag ">*</span>
              <span class="doublt" v-if="item.isTag">?</span>
            </div>
          </template>
        </div>
        <div class="title font14 text-center" style="margin-top: 10px;" v-if="!islow">
          Part A
        </div>
        <div class="list">
          <template v-for="item,index in list" v-if="!islow && (item.questionStatus==6)">
            <div @click="cindex=index">{{index+1}}
              <span class="star" v-if="!item.isDone && !item.isTag ">*</span>
              <span class="doublt" v-if="item.isTag">?</span>
            </div>
          </template>
        </div>
        <div class="title font14 text-center" style="margin-top: 10px;" v-if="!islow">
         Part B1
        </div>
        <div class="list">
          <template v-for="item,index in list" v-if="!islow && (item.questionStatus==7)">
            <div @click="cindex=index">{{index+1}}
              <span class="star" v-if="!item.isDone && !item.isTag ">*</span>
              <span class="doublt" v-if="item.isTag">?</span>
            </div>
          </template>
        </div>
        <div class="title font14 text-center" style="margin-top: 10px;" v-if="!islow">
         Part B2
        </div>
        <div class="list">
          <template v-for="item,index in list" v-if="!islow && (item.questionStatus==8)">
            <div @click="cindex=index">{{index+1}}
              <span class="star" v-if="!item.isDone && !item.isTag ">*</span>
              <span class="doublt" v-if="item.isTag">?</span>
            </div>
          </template>
        </div> -->
        <div class="des" style="color: #fe0303;padding: 15px;line-height: 26px;">
          说明</br>
          1.题号右方的“*”符号代表该小题尚未选择答案。</br>
          2.题号右方的“?”符号代表该小题做过标记。</br>
          3.选择选项的同时自动保存答案。

        </div>
        <div class="text-center"><img src="../assets/img/computericon.png" style="cursor: pointer;" @click="showcomputer=true"></div>
      </div>

      <div class="right flex1">
         <div style="padding: 15px;" v-if="islow && examObject.questionStatus>2">
           试卷
           <a class="mark_tg" id="mark" href="javascript:void(0)" @click="mark('yellow')" style="text-decoration: none;">标记文字</a>
          <a class="clear_tg" id="unmark" href="javascript:void(0)" @click="mark('#ddebf6')" style="text-decoration: none;">取消标记</a>
         </div>
         <div class="line">

         </div>
        <div class="type" style="padding: 15px;" v-if="examObject.questionStatus==0">
          判断题（请判断每小题的表述是否正确。每小题答题正确的得1分，错答、不答均不得分，也不扣分。请使用计算机鼠标在计算机答题界面上点击试题答案备选项前的按钮“○”作答。）
        </div>
        <div class="type" style="padding: 15px;" v-if="examObject.questionStatus==1">
          单选题（每小题备选答案中，只有一个符合题意的正确答案。错选、不选均不得分。请使用计算机鼠标在计算机答题界面上点击试题答案备选项前的按钮“○”作答。）
        </div>
        <div class="type" style="padding: 15px;line-height: 2;" v-if="examObject.questionStatus==2">
          多选题（每小题备选答案中，有两个或两个以上符合题意的正确答案。请至少选择两个答案，全部选对得满分，少选得相应分值，多选、错选、不选均不得分。请使用计算机鼠标在计算机答题界面上点击试题答案备选项前的按钮“□”作答。）
        </div>
        <div class="type" style="padding: 15px;line-height: 2;" v-if="examObject.questionStatus==3">
          计算题（每小题备选答案中，有一个或一个以上符合题意的正确答案。每小题全部选对得满分，少选得相应分值，多选、错选、不选均不得分。请使用计算机鼠标在计算机答题界面上点击试题答案备选项前的按钮“□”作答。）
        </div>
        <div class="type" style="padding: 15px;line-height: 2;" v-if="examObject.questionStatus==4">
          综合题 （凡要求计算的，应列出必要的计算过程；计算结果出现两位以上小数的，均四舍五入保留小数点后两位小数。凡要求编制会计分录的，除题中有特殊要求外，只需写出一级科目。答案中的金额单位用万元表示。请在指定答题区域内作答）
        </div>
        <div class="type" style="padding: 15px;line-height: 2;" v-if="examObject.questionStatus==5">
          完形填空 （凡要求计算的，应列出必要的计算过程；计算结果出现两位以上小数的，均四舍五入保留小数点后两位小数。凡要求编制会计分录的，除题中有特殊要求外，只需写出一级科目。答案中的金额单位用万元表示。请在指定答题区域内作答）
        </div>
        <div class="type" style="padding: 15px;line-height: 2;" v-if="examObject.questionStatus==6">
          PartA （凡要求计算的，应列出必要的计算过程；计算结果出现两位以上小数的，均四舍五入保留小数点后两位小数。凡要求编制会计分录的，除题中有特殊要求外，只需写出一级科目。答案中的金额单位用万元表示。请在指定答题区域内作答）
        </div>
        <div class="type" style="padding: 15px;line-height: 2;" v-if="examObject.questionStatus==7">
          PartB1 （凡要求计算的，应列出必要的计算过程；计算结果出现两位以上小数的，均四舍五入保留小数点后两位小数。凡要求编制会计分录的，除题中有特殊要求外，只需写出一级科目。答案中的金额单位用万元表示。请在指定答题区域内作答）
        </div>
        <div class="type" style="padding: 15px;line-height: 2;" v-if="examObject.questionStatus==8">
          PartB2 （凡要求计算的，应列出必要的计算过程；计算结果出现两位以上小数的，均四舍五入保留小数点后两位小数。凡要求编制会计分录的，除题中有特殊要求外，只需写出一级科目。答案中的金额单位用万元表示。请在指定答题区域内作答）
        </div>
        <div class="type" style="padding: 15px;line-height: 2;" v-if="examObject.questionStatus==9">
          翻译 （凡要求计算的，应列出必要的计算过程；计算结果出现两位以上小数的，均四舍五入保留小数点后两位小数。凡要求编制会计分录的，除题中有特殊要求外，只需写出一级科目。答案中的金额单位用万元表示。请在指定答题区域内作答）
        </div>
        <div class="type" style="padding: 15px;line-height: 2;" v-if="examObject.questionStatus==10">
          作文 （凡要求计算的，应列出必要的计算过程；计算结果出现两位以上小数的，均四舍五入保留小数点后两位小数。凡要求编制会计分录的，除题中有特殊要求外，只需写出一级科目。答案中的金额单位用万元表示。请在指定答题区域内作答）
        </div>
        <div class="type" style="padding: 15px;line-height: 2;" v-if="examObject.questionStatus==11">
          问题求解 （凡要求计算的，应列出必要的计算过程；计算结果出现两位以上小数的，均四舍五入保留小数点后两位小数。凡要求编制会计分录的，除题中有特殊要求外，只需写出一级科目。答案中的金额单位用万元表示。请在指定答题区域内作答）
        </div>
        <div class="type" style="padding: 15px;line-height: 2;" v-if="examObject.questionStatus==12">
          条件充分性判断 （凡要求计算的，应列出必要的计算过程；计算结果出现两位以上小数的，均四舍五入保留小数点后两位小数。凡要求编制会计分录的，除题中有特殊要求外，只需写出一级科目。答案中的金额单位用万元表示。请在指定答题区域内作答）
        </div>
        <div class="line">

        </div>
        <div class="exam" :class="{'signer':examObject.questionStatus<3}">
          <div class="font14" style="font-weight: bold;margin-top: 10px;" :class="{'signer':examObject.questionStatus>2}" v-if="islow || examObject.questionStatus<3">
            第{{cindex+1}}题
          </div>
          <div class="flex" style="margin-top: 10px;padding-left: 15px;padding-right: 15px;" v-else>
            <span>第{{cindex+1}}题</span>
            <span class="flex1"></span>
            <a class="mark_tg" id="mark" href="javascript:void(0)" @click="mark('yellow')" style="text-decoration: none;margin-right: 15px;">标记文字</a>
            <a class="clear_tg" id="unmark" href="javascript:void(0)" @click="mark('#fff')" style="text-decoration: none;">取消标记</a>
          </div>
          <template v-if="examObject.questionStatus==0 || examObject.questionStatus==1 || examObject.questionStatus==2">
            <div class="" style="margin-top: 20px;line-height: 2.5;" v-html="examObject.questionTitle">

            </div>
            <template v-if="examObject.questionStatus==0">
              <div class="options flex" v-for="item,index in examObject.optionList">
                <input type="radio" name="raido" id="" :value="item.optionId" v-model="ck" @change="handleRadio(index)" />
                <div>
                  <template v-if="index==0">A</template>
                  <template v-if="index==1">B</template>
                  <template v-if="index==2">C</template>
                  <template v-if="index==3">D</template>
                  <template v-if="index==4">E</template>
                  <template v-if="index==5">F</template>
                  、<span v-html="item.optionTitle"></span></div>
              </div>

            </template>
            <template v-if="examObject.questionStatus==1">
              <div class="options flex" v-for="item,index in examObject.optionList">
                <input type="radio" name="raido" id="" :value="item.optionId" v-model="ck" @change="handleRadio(index)" />
                <div>
                  <template v-if="index==0">A</template>
                  <template v-if="index==1">B</template>
                  <template v-if="index==2">C</template>
                  <template v-if="index==3">D</template>
                  <template v-if="index==4">E</template>
                  <template v-if="index==5">F</template>
                  、<span v-html="item.optionTitle"></span></div>
              </div>

            </template>

            <template v-if="examObject.questionStatus==2">
              <div class="options flex" v-for="item,index in examObject.optionList">
                <input type="checkbox" name="checkboxlist" :id="index" :value="item.optionId" v-model="checkboxlist"
                  @change="handleMoreSelect(index)" />
                <div>
                  <template v-if="index==0">A</template>
                  <template v-if="index==1">B</template>
                  <template v-if="index==2">C</template>
                  <template v-if="index==3">D</template>
                  <template v-if="index==4">E</template>
                  <template v-if="index==5">F</template>
                  、<span v-html="item.optionTitle"></span></div>
              </div>
            </template>
          </template>
              <div class="flex" >
                <template v-if="islow && (examObject.questionStatus==3 || examObject.questionStatus==4)">
                  <div class="scrollleft" ref="scrollleft" style="margin-top: 20px;width: 500px;height: 60vh;overflow-y: auto;line-height: 2.5;" v-html="examObject.questionTitle">

                  </div>

                  <div style="width: 6px;overflow: hidden;background: #a1b5fa;cursor: w-resize;" ref="resizeline"  @mousedown="handleChangeWidth($event)"></div>
                  <div class="flex1 scrollright" style="margin-left: 30px;height: 60vh;overflow-y: auto;">
                    <template v-for="voo,cindex in examObject.synthesizeList">
                      <div v-html="(cindex+1)+voo.questionTitle" style="margin-top: 20px;"></div>
                        <div>
               <!--           <template v-if="voo.questionStatus==1">
                            <div class="options flex" v-for="item,index in voo.optionList">
                              <input type="radio" :name="'raido'+cindex" id="" :value="item.optionId" v-model="item.selectedValue"
                                @change="handlemultiRadio()" />
                              <div>
                                <template v-if="index==0">A</template>
                                <template v-if="index==1">B</template>
                                <template v-if="index==2">C</template>
                                <template v-if="index==3">D</template>
                                <template v-if="index==4">E</template>
                                <template v-if="index==5">F</template>
                                、<span v-html="item.optionTitle"></span></div>
                            </div>

                          </template> -->

                          <template v-if="voo.questionStatus==1 || voo.questionStatus==2">
                            <div class="options flex" v-for="item,index in voo.optionList">
                              <input type="checkbox" name="checkboxlist" :id="index" :value="item.optionId" v-model="item.selectedValue"
                                @change="handlemulticheckboxlist()" />
                              <div>
                                <template v-if="index==0">A</template>
                                <template v-if="index==1">B</template>
                                <template v-if="index==2">C</template>
                                <template v-if="index==3">D</template>
                                <template v-if="index==4">E</template>
                                <template v-if="index==5">F</template>
                                、<span v-html="item.optionTitle"></span></div>
                            </div>
                          </template>
                          <template v-if="voo.questionStatus==3 || voo.questionStatus==4">
                            <textarea value="" placeholder="" />
                            </template>
                        </div>
                    	   </template>
                  </div>
                		</template>
                    <template v-if="examObject.questionStatus>4">
                      <div class="scrollleft" ref="scrollleft" style="margin-top: 20px;width: 500px;height: 60vh;overflow-y: auto;line-height: 2.5;" v-html="examObject.questionTitle">

                         </div>

                         <div style="width: 6px;overflow: hidden;background: #a1b5fa;cursor: w-resize;" ref="resizeline"  @mousedown="handleChangeWidth($event)"></div>
                         <div class="flex1 scrollright" style="margin-left: 30px;height: 60vh;overflow-y: auto;">
                           <template v-for="voo,cindex in examObject.gestaltOptionList">
                             <div v-html="(cindex+1)" style="margin-top: 20px;" v-if="examObject.questionStatus==5"></div>
                             <div v-html="(cindex+1 )+'. '+voo.optionsName" style="margin-top: 20px;" v-else></div>
                               <div>
                      <!--           <template v-if="voo.questionStatus==1">
                                   <div class="options flex" v-for="item,index in voo.optionList">
                                     <input type="radio" :name="'raido'+cindex" id="" :value="item.optionId" v-model="item.selectedValue"
                                       @change="handlemultiRadio()" />
                                     <div>
                                       <template v-if="index==0">A</template>
                                       <template v-if="index==1">B</template>
                                       <template v-if="index==2">C</template>
                                       <template v-if="index==3">D</template>
                                       <template v-if="index==4">E</template>
                                       <template v-if="index==5">F</template>
                                       、<span v-html="item.optionTitle"></span></div>
                                   </div>

                                 </template> -->

                                 <template>
                                   <div class="options flex" v-for="item,index in voo.optionList">
                                     <input type="radio" name="checkboxlist" :id="index" :value="item.optionId" v-model="item.selectedValue"
                                       @change="handlemulticheckboxlist()" />
                                     <div style="display: flex;">
                                       <template v-if="index==0">A</template>
                                       <template v-if="index==1">B</template>
                                       <template v-if="index==2">C</template>
                                       <template v-if="index==3">D</template>
                                       <template v-if="index==4">E</template>
                                       <template v-if="index==5">F</template>
                                       <template v-if="index==6">G</template>
                                       <template v-if="index==7">H</template>
                                       <template v-if="index==8">I</template>
                                       <template v-if="index==9">J</template>
                                       <template v-if="index==10">K</template>
                                       、<span v-html="item.options"></span></div>
                                   </div>
                                 </template>
                                 <template v-if="voo.questionStatus==3 || voo.questionStatus==4">
                                   <textarea value="" placeholder="" />
                                   </template>
                               </div>
                           	   </template>
                               <template  v-if="examObject.questionStatus==9 || examObject.questionStatus==10">
                                 <textarea placeholder="请输入您的答案" v-model="examObject.content"></textarea>
                               </template>
                         </div>
                    </template>

              </div>
              <template  v-if="!islow && (examObject.questionStatus==3 || examObject.questionStatus==4)">
                <div class="tops" ref="tops" v-html="examObject.questionTitle"></div>
                <div class="middleLine" @mousedown="handleChangeHeight($event)"></div>
                <div class="btnlist flex">
                  <span v-for="item,index in examObject.synthesizeList.length" @click="smallindex=index" class="ask" :class="{'askactive':index==smallindex}">
                      要求{{index+1}}
                  </span>
                  <span class="flex1"></span>
                  <a href="javascript:void(0)"  class="flex" style="margin-top: 10px;cursor: pointer;" @click="copyMEditor">
                    <img src="../assets/img/copy.png" width="20" height="20" />
                    复制
                  </a>
                   <span class="flex" style="margin-top: 10px;margin-left:15px;cursor: pointer;" @click="pasteEditor">
                    <img src="../assets/img/paste.png" width="20" height="20" />
                    粘贴
                  </span>
                  <a href="javascript:void(0)"   class="flex" style="margin-top: 10px;margin-left:15px;cursor: pointer;" @click="cutEditor">
                    <img src="../assets/img/cut.png" width="20" height="20" />
                    剪切
                  </a>
                   <span class="flex" style="margin-top: 10px;margin-left:15px;margin-right: 15px;cursor: pointer;">
                    <img src="../assets/img/formula.png" width="20" height="20" />
                    公式符号
                  </span>
                </div>
                <div class="questionConents" v-for="item,index in examObject.synthesizeList.length">
                      <template v-if="smallindex==index">
                        <div class="titles" v-html="examObject.synthesizeList[index].questionTitle"></div>
                        <textarea value="" placeholder="" v-model="examObject.synthesizeList[index].content" />
                      </template>
                </div>
              </template>
    					<div class="flex options" style="padding-left: 15px;">
    						<input type="checkbox" name="" id="" value="" v-model="examObject.isTag" />
    						<span class="tag font18" style="font-weight: bold;">标记</span>
    						<span class="prev" v-if="cindex>0" @click="handlePrev()">上一题</span>
    						<span class="prev" v-if="cindex<list.length-1" @click="handleNext()">下一题</span>
    					</div>
    				</div>
    			</div>
    		</div>
        <tips v-if="showTips" @handleCloseTips="showTips=false" @handleSubmit="handleSubmit" :listlength="listlength" :donelist="donelist"></tips>
        <div style="position: fixed;right: 30px;top:50px" v-if="showcomputer"><computer @handleClose="showcomputer=false"></computer></div>
  </div>
</template>

<script>
  import computer from './compute.vue'
  let copyContent;
  document.addEventListener('copy', function() {
                  var content = window.getSelection().toString();
                  copyContent=content
  })
  document.onkeydown=function(e){


    if(e.code=='F5'){
      e.preventDefault()
    }

  }
  let timer;
  import tips from './submtiquestiontips.vue'
	export default {
	  name: 'Footer',
    components:{
      tips,
      computer
    },
	  data () {
	    return {
	        data:'',
	        title:'模拟考试',
	        pageNo:1,
	        pageSize:1000,
				  questionsStatus:this.$route.query.questionsStatus,
				  testQuestionsId:this.$route.query.testQuestionsId,
          storageTag:this.$route.query.storageTag,
          title:this.$route.query.title,
          seconds:this.$route.query.minutes*60,
          minutes:this.$route.query.minutes*60,
				  list:[],
          cindex:-1,
          examObject:{},
          ck:'',
          checkboxlist:[],
          showTips:false,
          listlength:0,
          donelist:0,
          multick:[[]],
          multicheckboxlist:[],
          startTime:new Date().getTime(),
          timeString:'00:00:00',
          totalScore:0,
          showloading:true,
          showcomputer:false,
          iscan:false,
          islow:this.$route.query.oneCategoryId==13?true:false,
          smallindex:0,
          leftList:[{
            name:'判断题',
            list:[]
          },
          {
            name:'单项选择题',
            list:[]
          },
          {
            name:'多项选择题',
            list:[]
          },
          {
            name:'计算题',
            list:[]
          },
          {
            name:'综合题',
            list:[]
          },
          {
            name:'完形填空',
            list:[]
          },
          {
            name:'阅读理解PartA',
            list:[]
          },
          {
            name:'阅读理解PartB1',
            list:[]
          },
          {
            name:'阅读理解PartB2',
            list:[]
          },
          {
            name:'翻译',
            list:[]
          },
          {
            name:'作文',
            list:[]
          },
          {
            name:'问题求解',
            list:[]
          },
          {
            name:'条件充分性判断',
            list:[]
          }

          ]
	    }
	  },
	  methods:{
      copyMEditor(){
          copyContent=''
          var range, sel = window.getSelection();
          if (sel.rangeCount && sel.getRangeAt) {
              range = sel.getRangeAt(0);
          }
          document.designMode = "on";
          if (range) {
              sel.removeAllRanges();
              sel.addRange(range);
          }
          // Use HiliteColor since some browsers apply BackColor to the whole block
          if (!document.execCommand("Copy", false)) {
              document.execCommand("Copy", false);
          }
          document.designMode = "off";

          if (window.getSelection) {
          		window.getSelection().removeAllRanges();
          	} else if (document.selection) {
          		document.selection.empty();
          	}
      },
      pasteEditor(){
          this.examObject.synthesizeList[this.smallindex].content=this.examObject.synthesizeList[this.smallindex].content||''
          this.examObject.synthesizeList[this.smallindex].content+=copyContent
      },
      cutEditor(){
        copyContent=''
        var content = window.getSelection().toString();
        copyContent=content;
        var index=this.examObject.synthesizeList[this.smallindex].content.lastIndexOf(content);
            this.examObject.synthesizeList[this.smallindex].content=this.examObject.synthesizeList[this.smallindex].content.slice(0,index)+this.examObject.synthesizeList[this.smallindex].content.slice(index+content.length)
      },
      mark(color){
        var range, sel = window.getSelection();
        if (sel.rangeCount && sel.getRangeAt) {
            range = sel.getRangeAt(0);
        }
        document.designMode = "on";
        if (range) {
            sel.removeAllRanges();
            sel.addRange(range);
        }
        // Use HiliteColor since some browsers apply BackColor to the whole block
        if (!document.execCommand("HiliteColor", false, color)) {
            document.execCommand("BackColor", false, color);
        }
        document.designMode = "off";

        if (window.getSelection) {
        		window.getSelection().removeAllRanges();
        	} else if (document.selection) {
        		document.selection.empty();
        	}
      },
      handleChangeWidth(e){

        this.iscan=true
        let exam=document.querySelector('.exam').getBoundingClientRect().left
     //   this.$refs.scrollleft.style.width="100px";
        let vm=this
        document.onmousemove=function(event){
          if(!vm.iscan){
            return
          }
          console.log(event)
       //   vm.$refs.resizeline.style.left=event.screenX
          if((event.screenX-exam-40-3<100)){

            return
          }
          console.log(event.screenX>window.innerWidth)
          if((event.screenX>window.innerWidth-430)){
            console.log(555)
            return
          }
          vm.$refs.scrollleft.style.width=event.screenX-exam-40-3+'px';
        }
        document.onmouseup=function(){
          vm.iscan=false;
        }
        if (window.getSelection) {
        		window.getSelection().removeAllRanges();
        	} else if (document.selection) {
        		document.selection.empty();
        	}
      },
      handleChangeHeight(){
        this.iscan=true
           let offsetTop=this.$refs.tops.offsetTop;
           console.log(offsetTop)
           let vm=this
           document.onmousemove=function(event){
             if(!vm.iscan){
               return
             }
             console.log(event)
          //   vm.$refs.resizeline.style.left=event.screenX
            if((event.clientY>window.innerHeight-130)){
              console.log(555)
              return
            }
             vm.$refs.tops.style.height=(event.clientY-offsetTop-30)+'px';
           }
           document.onmouseup=function(){
             vm.iscan=false;
           }
           if (window.getSelection) {
           		window.getSelection().removeAllRanges();
           	} else if (document.selection) {
           		document.selection.empty();
           	}
      },
      handleSave(){
        let time=Math.floor((new Date().getTime()-this.startTime)/1000/60)
        let datas=new FormData();
            datas.append('testQuestionsId',this.testQuestionsId);
            datas.append('content', JSON.stringify(this.list));
            datas.append('min',time);
        this.$axios.post(this.$common.temporaryStorageSub_url,datas).then((res)=>{
              if(res.data.code==1){
                  alert('已保存');
                  this.$router.push('history')
              }
              else {
                alert(res.data.msg)
              }
        })
      },
      handleDelete(){
        let time=0
        let datas=new FormData();
            datas.append('testQuestionsId',this.testQuestionsId);
            datas.append('content', '');
            datas.append('min',time);
        this.$axios.post(this.$common.temporaryStorageSub_url,datas).then((res)=>{
              if(res.data.code==1){
             //     alert('已保存')
              }
              else {
                alert(res.data.msg)
              }
        })
      },
      handlemultiRadio(){
          this.examObject.isDone=true;
      },
      handlemulticheckboxlist(){
        this.examObject.isDone=true;
      },
      handleAlertTips(){
        this.donelist=this.list.filter((item)=>{return item.isDone}).length;
        this.showTips=true;
      },
      handleSubmit(){  //交卷
        this.handleDelete();
        this.handleSaveAnalysis();
        let myScore=0;
        let undoCount=0;
        this.list.forEach((item)=>{
              if(!item.isDone){
                undoCount++
              }
              if(item.questionStatus==1 || item.questionStatus==2){

                   if(item.isDone){
                     var tag=item.optionList.every((voo)=>{
                       return voo.selected==voo.optionAnswerStatus
                     })

                     if(tag){
                       item.answerStatus==1;
                       myScore+=item.questionScore
                     }
                     else {
                       item.answerStatus=0
                     }
                   }

              }

              if(item.questionStatus==3 || item.questionStatus==4){

                    if(item.isDone){
                      item.answerStatus=1;
                      myScore+=item.questionScore
                    }
              }
              if(item.questionStatus==5 || item.questionStatus==6 || item.questionStatus==7){
                    item.isDone=item.gestaltOptionList.some((voo)=>{
                       return voo.optionList.some((voos)=>{
                         return voos.selectedValue
                       })
                    })

                    if(item.isDone){
                        item.answerStatus=item.gestaltOptionList.every((voo)=>{
                           return voo.optionList.every((voos)=>{
                                return voos.optionAnswerStatus==voos.selectedValue
                           })
                        })?1:0;
                        let rightCount=item.gestaltOptionList.filter((voo)=>{
                                return voo.optionList.every((voos)=>{
                                     return !!voos.optionAnswerStatus==!!voos.selectedValue
                                })
                        }).length
                        myScore+=item.questionScore / item.gestaltOptionList.length * rightCount;
                        console.log(myScore,'myScore')
                    }
                    else {
                      item.answerStatus=0
                    }
                    console.log(item)
              }
        })

        let correctNum=this.list.filter((item)=>{ return item.answerStatus==0}).length;
            console.log(correctNum)
            let data=new FormData();
                data.append('totalNum',this.list.length);
                data.append('correctNum',correctNum);
                data.append('questionMinute',Math.floor((new Date().getTime()-this.startTime)/1000/60));
            this.$axios.post(this.$common.personal_statisticsSub,data).then((res)=>{
                  if(res.data.code==1){

                  }
                  else {
                    alert(res.data.msg)
                  }
            })

            let datas=new FormData();
                datas.append('errorQuestionStatus',this.errorQuestionStatus);
                datas.append('testQuestionsId',this.testQuestionsId);
                datas.append('chapterId',this.testQuestionsId);
                datas.append('testQuestions', JSON.stringify(this.list));
                datas.append('childQuestionStatus',this.questionsStatus);

            this.$axios.post(this.$common.testPaper_testPaperQuestionSub,datas).then((res)=>{
                  if(res.data.code==1){
                   //   var time=Math.floor((new Date().getTime()-this.startTime)/1000/60)
                      var time=parseInt((this.minutes-this.seconds)/60)
                      this.$router.replace('examsresult?totalScore='+this.totalScore+'&myScore='+myScore+'&undoCount='+undoCount+'&title='+this.title+'&count='+this.list.length+'&time='+time)
                  }
                  else {
                    alert(res.data.msg)
                  }
            })



      },
      handleSaveAnalysis(){
        let datas=new FormData();
            datas.append('content', JSON.stringify(this.list));
        this.$axios.post(this.$common.answerAnalysisSub_url,datas).then((res)=>{
              if(res.data.code==1){

              }
              else {
                alert(res.data.msg)
              }
        })
      },
	    getData(){ //获取数据
			var url=this.$common.testPaper_testPaperQuestionList;
				if(this.questionsStatus>2){

					url=this.$common.testPaper_selectTestQuestionListByPageSize
				}
	      let data={
	        pageNo:this.pageNo,
	        pageSize:this.pageSize,
	        testQuestionsId:this.testQuestionsId
	      };
	      this.$axios.get(url,{params:data}).then((res)=>{
              this.showloading=false;
	            if(res.data.code==1){
                  var list=res.data.data;
                      list.forEach((item)=>{
                            item.isDone=false;
                            item.isTag=false;
                            this.totalScore+=item.questionScore;

                      })
                  list.forEach((item,index)=>{
                    this.leftList[item.questionStatus].list.push({
                        index:index,
                        obj:item
                    })
                    this.leftList[item.questionStatus].questionScore=item.questionScore
                  })
	                this.list=list;
                  this.listlength=list.length;
                  this.cindex=0;
                  console.log(this.totalScore)
	            }
	            else {
	              alert(res.data.msg)
	            }
	      })
	    },
      getTemporaryStorage(){
        this.$axios.get(this.$common.temporaryStorage_url+'?testQuestionsId='+this.testQuestionsId).then((res)=>{
              this.showloading=false;
              if(res.data.code==1){

                  this.list=JSON.parse(res.data.data.content);
                  this.list.forEach((item,index)=>{
                    this.leftList[item.questionStatus].list.push({
                        index:index,
                        obj:item
                    })
                    this.leftList[item.questionStatus].questionScore=item.questionScore
                  })
                  this.list.forEach((item)=>{

                        this.totalScore+=item.questionScore;

                  })
                  this.seconds=this.seconds-res.data.data.min*60
                  this.listlength=this.list.length;
                  for(let i=0;i<this.list.length;i++){

                    if(this.list[i].isDone==false){

                      this.cindex=i;
                      break;
                    }
                  }

               //   this.cindex=0;
              }
              else {
                alert(res.data.msg)
              }
        })
      },
      handleRadio(cindex){  //单选
          this.examObject.isDone=true;
          console.log(cindex)
          this.examObject.optionList.forEach((item,index)=>{
            if(cindex==index){
              item.selected=true;
            }
            else {
              item.selected=false;
            }
          })
      },
      handleNext(){  //下一题
        this.cindex++
      },
      handlePrev(){  //上一次
        this.cindex--
      },
      handleMoreSelect(index){

        this.examObject.optionList[index].selected=!this.examObject.optionList[index].selected
        console.log(this.checkboxlist)
        if(this.checkboxlist.length>0){
          this.examObject.isDone=true;
        }
        else {
          this.examObject.isDone=false;
        }
      }
	  },
	  created(){
	    if(this.storageTag==0){
        this.getData();
      }
      else {
        this.getTemporaryStorage();
      }
      timer=setInterval(()=>{
        this.seconds--;
      //  console.log(this.seconds)
      },1000)

	  },
    watch:{
      seconds(val){
        if(val<=0){

          clearInterval(timer);
          this.handleSubmit();
        }
        else {
          let h=Math.floor(this.seconds/60/60);
          let i=Math.floor(this.seconds/60);
              i=i-h*60;
          let s=this.seconds%60;
              h=h>9?h:'0'+h;
              i=i>9?i:'0'+i;
              s=s>9?s:'0'+s;
          this.timeString=h+":"+i+':'+s
        }
      },
      cindex(val){
        this.$forceUpdate()
        this.examObject=this.list[val];
        console.log(this.examObject)
        var list=this.examObject.optionList.filter((item)=>{
             return item.selected
        })
        if(this.examObject.questionStatus==1){ //单选
          if(list.length>0){
            this.ck=list[0].optionId
          }
          else {
            this.ck=''
          }
        }
        else {
          if(list.length>0){
              this.checkboxlist=list.map((item)=>{
                return item.optionId
              })
          }
          else {
            this.checkboxlist=[];
          }
        }

        var scrollleft=document.querySelector(".scrollleft");
        var scrollright=document.querySelector(".scrollright")
            scrollleft && (scrollleft.scrollTop=0);
            scrollright && (scrollright.scrollTop=0);
      }
    },
    computed:{
        errorQuestionStatus(){
          if(this.questionsStatus==1){

              return 1
          }
          if(this.questionsStatus==2){

              return 2
          }
          if(this.questionsStatus==3){

              return 3
          }
          if(this.questionsStatus==4){

              return 4
          }
          if(this.questionsStatus==5){

              return 4
          }
          if(this.questionsStatus==6){

              return 5
          }
          if(this.questionsStatus==7){

              return 5
          }
        }
    }
	}
</script>

<style scoped="">
  .onlinetest {
  	background-color: #ddebf6;
  }
  .top {
  	height: 120px;
  	background-color: #4fa7ff;
  	padding: 0 30px;
  	display: flex;
  	align-items: center;
  }
  .btn {
  	font-size: 14px;
  	width: 80px;
  	line-height: 40px;
  	background-color: #ffcd34;
  	text-align: center;
  	border: 1px solid #000;
    cursor: pointer;
  }
  .left {
  	width: 420px;
  	border: 1px solid #ccc;
  	background-color: #fff;
  	padding-bottom: 30px;
  }
  .right {
  	border: 1px solid #ccc;
  	margin-left: 10px;
  }
  .title {
  	background-color: #5ea3d7;
  	line-height: 40px;
  	border-radius: 2px;
  	font-weight: bold;
  }
  .list {
  	display: flex;
  	flex-wrap: wrap;


  }
  .left .list {
    padding-left: 15px;
  }
  .list div {
  	width: 28px;
  	height: 28px;
  	background-color: #ddebf6;
  	margin-right: 10px;
  	display: inline-block;
  	line-height: 28px;
  	font-size: 14px;
  	text-align: center;
  	margin-top: 10px;
    cursor: pointer;

  }
  .star {
  	color: red;
  }
  .doublt {
  	font-size: 11px;
  	color: red;
  	position: relative;
  	bottom: 5px;
  	display: inline-block;
  }
  .line {
  	height: 1px;
  	background-color: #ccc;
  	width: 100%;
  }
  .signer {
    padding-left: 40px;
  }
  .options {
  	align-items: center;
  	margin-top: 30px;
  	color: #101010;

  }
  .scrollleft {
    padding-left: 40px;
  }
  .options input {
  	margin-right: 10px;
  	width: 15px;
  	height: 15px;
  }
  .prev {
  	font-size: 14px;
  	width: 95px;
  	height: 40px;
  	line-height: 40px;
  	background-color: #fff;
  	border: 1px solid #ccc;
  	text-align: center;
  	margin-left: 25px;
  	cursor: pointer;
  }
  .tops {
    background-color: #fff;
    padding: 15px;
    margin-top: 15px;
    height: 250px;
    overflow-y: auto;
  }
  .options {

  }
  .middleLine {
    height: 6px;
    background-color: #9fb7f7;
    cursor: row-resize;
  }
  textarea {
    width: 90%;
    height: 150px;
    outline: none;
    margin-top: 15px;
  }
  .ask {
    width: 66px;
        height: 25px;
        margin-top: 5px;
        text-align: center;
        cursor: pointer;
        display: inline-block;
        border: 1px solid #000;
        margin-left: 10px;
        border-bottom: none;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        background-color: #DCDFE0;
        margin-bottom: 10px;
  }
  .askactive {
    background-color: #FDB04D;
  }
  .mark_tg,.clear_tg {
    background: #B8CFEF;
    border: 1px solid #4fa7ff;
    padding: 2px 4px;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/onlinetest.vue